document.querySelectorAll('.facets--title-main').forEach(function(el){
  el.addEventListener('click', function(){
    document.querySelector('.collection-wrapper').classList.toggle('active');
    document.querySelector('.facets-block-wrapper--vertical').classList.toggle('active'); 
     document.querySelector('.content-for-layout').classList.toggle('active-toggle-w'); 
     
  });
});
document.querySelectorAll('.size_chart-button').forEach(function(el){
  el.addEventListener('click', function(){
    document.querySelector('.size_main, .size_wrapper').classList.toggle('active');
  });
});
document.querySelectorAll('.icon_close').forEach(function(el){
  el.addEventListener('click', function(){
    document.querySelector('.size_main, .size_wrapper').classList.remove('active');
  });
});


$(document).on('click', '.tab-btn', function () {
  const tabId = $(this).attr('data-tab');
  const parent = $(this).closest('.tabs');
  const mainParent = $(this).closest('#MainContent');
  parent.find('.tab-btn').removeClass('active');
  parent.find('.tab-content').removeClass('active');
  mainParent.find('.style_switch.tab-content').removeClass('active');
  console.log(tabId,'tabId>>>>',`#${tabId}`);
  $(this).addClass('active');
  $(`#${tabId}`).addClass('active');
 mainParent.find(`[data-sid="${tabId}"]`).addClass('active');
});

$('.text-scroll-slider .group-block-content').slick({
  dots: false,
  arrows:false,
  infinite: true,
  speed: 300,
  slidesToShow: 1,
  autoplay: true,
  autoplaySpeed: 2000,
    fade: true
});


$('.slide_show-3-item').slick({
  dots: false,
  infinite: false,
  arrows:true,
  speed: 300,
  slidesToShow: 5,
  slidesToScroll: 3,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3.5,
        slidesToScroll: 3,
        infinite: true,
      }
    },
    {
      breakpoint: 750,
      settings: {
        slidesToShow: 2.5,
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 2.5,
        slidesToScroll: 2
      }
    }
  ]
  });
$(document).on('click','.btn_click',function() {
    $('.estimate_product-wrap').css('display', 'flex');
});
$(document).on('click','.icon_close',function() {
    $('.estimate_product-wrap').hide();
});


$(document).on('click', 'details', function() {
    if (window.innerWidth <= 768) {
        $('.shopify-section-group-footer-group details').removeAttr('open');
        $('.pro-faq-section details').removeAttr('open');
    }
});


  if ($(window).width() >= 750) {
      var $items = $('.js-deskhotspot-slider .custom-product-hotspoot-wrapp');
      for (var i = 0; i < $items.length; i += 3) {
        $items.slice(i, i + 3).wrapAll('<div class="group-hotspot-product"></div>');
      }
   
  }

function initSliders() {
  const width = window.innerWidth;

  const $mobile = $('.js-hotspot-slider');
  const $desktop = $('.js-deskhotspot-slider');

  if (width < 1024) {
    if (!$mobile.hasClass('slick-initialized')) {
      $mobile.slick({
        mobileFirst: true,
        dots: false,
        arrows: true,
        speed: 300,
        slidesToShow: 1,
        slidesToScroll: 1
      });
    }
  } else if ($mobile.hasClass('slick-initialized')) {
    $mobile.slick('unslick');
  }

  if (width >= 750) {
    if (!$desktop.hasClass('slick-initialized')) {
      $desktop.slick({
        dots: false,
        arrows: true,
        speed: 300,
        slidesToShow: 1,
        slidesToScroll: 1
      });
    }
  } else if ($desktop.hasClass('slick-initialized')) {
    $desktop.slick('unslick');
  }
}


// Promo tile inside the collection product grid (sections/main-collection.liquid).
// It renders one <div> per image from the collection's custom.grid_slides list;
// with two or more it becomes a carousel, with one it stays a plain image.
function initCollectionAdSlider() {
  const $slider = $('.collection-ad-slider');
  if (!$slider.length || $slider.hasClass('slick-initialized')) return;
  if ($slider.children('.collection-ad-slider__slide').length < 2) return;

  $slider.slick({
    dots: true,
    arrows: false,
    fade: true,
    autoplay: true,
    autoplaySpeed: 4000,
    speed: 600,
    slidesToShow: 1,
    slidesToScroll: 1,
    pauseOnHover: true
  });
}

$(window).on('load resize', initCollectionAdSlider);
document.addEventListener('shopify:section:load', initCollectionAdSlider);
$(initCollectionAdSlider);

$(window).on('load resize', initSliders);

  document.addEventListener('shopify:section:load', function () {
    initSliders();
      
  });

  document.addEventListener('shopify:section:select', function () {
      initSliders();
  });

  document.addEventListener('shopify:block:select', function () {
      initSliders();
  });


$(window).on('scroll', function () {
  $('body').toggleClass(
    'header-scrolled',
    $(window).scrollTop() > ($('#header-component').outerHeight())
  );
});

/*
 * Publishes --bottom-bar-height so the floating widgets (WhatsApp bubble,
 * product video tile) can sit above whatever app-rendered bar is pinned to the
 * bottom of the viewport - currently Vitals' Sticky Add to Cart Bar, which is
 * mobile-only and was overlapping the WhatsApp button.
 *
 * Measured rather than hardcoded: the bar's height moves with its own settings
 * (variant picker, quantity row), with a title that wraps, and with the iOS
 * safe-area inset. base.css consumes the variable; when no bar is present it
 * stays 0px and the widgets keep their original offsets.
 */
(function trackBottomBarHeight() {
  var OWN_WIDGETS = '.whatsapp-float-wrapp, .floating-whatsapp, .fv-trigger, .video-popup';
  // Shopify's theme preview bar is staff-only - ignore it so previews match production.
  var IGNORED = '#PBarNextFrameWrapper';
  var queued = false;

  // Does this element actually paint something, or is it an invisible wrapper?
  function paints(styles) {
    if (styles.backgroundImage && styles.backgroundImage !== 'none') return true;
    var match = /rgba?\(([^)]+)\)/.exec(styles.backgroundColor || '');
    if (!match) return false;
    var parts = match[1].split(',');
    return parts.length < 4 || parseFloat(parts[3]) > 0.05;
  }

  function nearestFixed(el) {
    for (var node = el; node && node !== document.body; node = node.parentElement) {
      if (window.getComputedStyle(node).position === 'fixed') return node;
    }
    return null;
  }

  /*
   * Asks what is painted in the corner the WhatsApp bubble sits in, and lifts the
   * widgets only if that turns out to be a bar pinned to the bottom.
   *
   * Two earlier approaches were wrong. Scanning for fixed elements by geometry
   * counted the 132px of body padding Vitals reserves from page load, so the
   * widgets floated high on a page showing no bar. Hit-testing alone still
   * matched the app's container, which is hit-testable well before the bar
   * animates in - it is simply transparent until then. So the first *painted*
   * thing at that point decides: page content means no bar, a fixed bar means
   * lift by its on-screen height.
   *
   * Sampled 4px off the bottom edge, below anything we position ourselves, so
   * our own widgets can never trigger it.
   */
  function measure() {
    var x = Math.max(0, window.innerWidth - 43);
    var y = window.innerHeight - 4;
    var stack = document.elementsFromPoint(x, y) || [];
    var tallest = 0;

    // The stack is not reliably topmost-first, so every entry gets examined
    // rather than letting the first painted one decide.
    for (var i = 0; i < stack.length; i++) {
      var el = stack[i];
      if (el.closest(OWN_WIDGETS) || el.closest(IGNORED)) continue;

      var styles = window.getComputedStyle(el);
      if (parseFloat(styles.opacity) < 0.05) continue;
      if (!paints(styles)) continue;

      var bar = nearestFixed(el);
      if (!bar) continue; // ordinary page content painting there - not a bar

      var rect = bar.getBoundingClientRect();
      // Ignore hairlines and full-screen overlays (drawers, modals, login iframes).
      if (rect.height < 20 || rect.height > 220) continue;
      if (rect.width < window.innerWidth * 0.7) continue;

      // Height on screen, so a bar mid-slide lifts them only as far as it has come.
      // Keep the tallest match: a bar painted by a child still measures its own box.
      tallest = Math.max(tallest, Math.round(Math.max(0, window.innerHeight - rect.top)));
    }

    return tallest;
  }

  function publish() {
    queued = false;
    document.body.style.setProperty('--bottom-bar-height', measure() + 'px');
  }

  function schedule() {
    if (queued) return;
    queued = true;
    window.requestAnimationFrame(publish);
  }

  document.addEventListener('scroll', schedule, { passive: true });
  window.addEventListener('resize', schedule);
  window.addEventListener('load', schedule);
  // App bars mount late and animate themselves in and out.
  new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });

  publish();
})();

/*
 * Gate the app sticky add-to-cart bar (Vitals, #bundle-sticky_add_to_cart) on
 * the product's own Add to cart button: shown only once the shopper has
 * scrolled past it; hidden while it is on screen or still below the fold. The app's own "when to show" trigger fires on
 * the first scroll event regardless of where the button is, which on desktop
 * looks like the bar is there from the start. base.css hides the bar while
 * body carries .theme-atc-visible; layout/theme.liquid puts that class on the
 * body of every product template so it holds from first paint - this script
 * loads late, and setting it here left a flash before it ran.
 */
(function gateStickyBarOnAtcButton() {
  var button = document.querySelector('product-form-component .add-to-cart-button, .add-to-cart-button');
  // No button to watch (or no observer support): never leave the bar hidden.
  if (!button || !('IntersectionObserver' in window)) {
    document.body.classList.remove('theme-atc-visible');
    return;
  }

  // "Passed" means the button has gone out above the viewport. Below the fold
  // (not reached yet) keeps the bar hidden too - on desktop the button sits
  // under the fold at load, and showing the bar then reads as "from the start".
  new IntersectionObserver(function (entries) {
    var entry = entries[entries.length - 1];
    var passed = !entry.isIntersecting && entry.boundingClientRect.bottom <= 0;
    document.body.classList.toggle('theme-atc-visible', !passed);
  }, { threshold: 0 }).observe(button);
})();
